<template>
  <ElContainer>
    <ElAside
      :width="isCollapsed ? '60px' : '200px'"
      class="el-aside"
      style="position: fixed; top: 0"
    >
      <NavigationBar
        :is-collapsed="isCollapsed"
        @toggle-collapse="isCollapsed = !isCollapsed"
      />
    </ElAside>
    <ElContainer :style="{ marginLeft: isCollapsed ? '60px' : '200px' }">
      <ElHeader
        class="el-header"
        :style="{
          position: 'fixed',
          top: 0,
          left: isCollapsed ? '60px' : '200px',
          right: 0,
          paddingLeft: 0,
        }"
      >
        <TitleBar :key="refreshTitleBarKey" />
      </ElHeader>
      <ElMain
        :style="{
          position: 'fixed',
          top: '60px',
          width: isCollapsed ? 'calc(100% - 60px)' : 'calc(100% - 200px)',
          height: 'calc(100vh - 60px)',
        }"
      >
        <RouterView />
      </ElMain>
    </ElContainer>
  </ElContainer>
</template>

<script setup lang="ts">
import NavigationBar from "@/components/NavigationBar.vue";
import TitleBar from "@/components/TitleBar.vue";
import { useRefreshComponent } from "@/stores/refreshComponent";
import { ref } from "vue";

const { refreshTitleBarKey } = useRefreshComponent();
const isCollapsed = ref(false);
</script>

<style scoped>
.el-aside {
  /* Fixed positioning for the navbar */
  @apply transition-all duration-300 fixed top-0 left-0 z-0 h-screen;
  background: linear-gradient(180deg, #ffffff 10%, #e0f1ff 100%);
}

.el-header {
  background: linear-gradient(90deg, #ffffff 10%, #e0f1ff 100%);
}
</style>
